const CONFIG = {
	API_PATH: API_PATH,
	PRODUCTION_ROOT: '/rest/methods',
};

export const API = {
	...CONFIG,

	GET: `GET /${(CONFIG.API_PATH)}`,
	POST: `POST /${(CONFIG.API_PATH)}`,

	PROD_URL: `${CONFIG.PRODUCTION_ROOT}`,
	PROD_USER: `${CONFIG.PRODUCTION_ROOT}/user`,
	PROD_CATALOG: `${CONFIG.PRODUCTION_ROOT}/catalog`,

	DEVELOP_URL: `${CONFIG.PRODUCTION_ROOT}`,
	DEVELOP_USER: `${CONFIG.PRODUCTION_ROOT}/user`,
	DEVELOP_CATALOG: `${CONFIG.PRODUCTION_ROOT}/catalog`,

	SAND_URL: `${CONFIG.API_PATH}${CONFIG.PRODUCTION_ROOT}`,
	SAND_USER: `${CONFIG.API_PATH}${CONFIG.PRODUCTION_ROOT}/user`,
	SAND_CATALOG: `${CONFIG.API_PATH}${CONFIG.PRODUCTION_ROOT}/catalog`,
};
